import { render } from "./servingOrder.vue?vue&type=template&id=1e3b2caf"
import script from "./servingOrder.vue?vue&type=script&lang=js"
export * from "./servingOrder.vue?vue&type=script&lang=js"

import "./servingOrder.vue?vue&type=style&index=0&id=1e3b2caf&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__